import React from 'react'
import { ErrorMessageProps, useField } from 'formik'
import styled from 'styled-components'

const Error = styled.div`
  color: #f00;
  font-size: 0.75rem;
  line-height: 1.125rem;
`

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ name }: ErrorMessageProps) => {
  const [_field, meta] = useField(name) // eslint-disable-line @typescript-eslint/no-unused-vars

  return meta?.touched && meta?.error ? <Error>{meta.error}</Error> : <Error>&nbsp;</Error>
}
